const Style = {

  base: 'absolute left-1/2 top-1/2 flex -translate-y-1/2 -translate-x-1/2 items-center justify-center',

}

export default Style;
